import { render } from "preact";
import { App } from "./app/App.tsx";
import { initApi, initAuth, sessionLost, startSession } from "./app/actions.ts";
import { createAuth } from "../../ui/src/index.ts";
import { initStore, initialState, type Config } from "./app/store.ts";

// The build copies one environment's config next to the bundle.
const res = await fetch("/config.json");
if (!res.ok) throw new Error("Couldn't load /config.json");
// SAFETY: console/build.ts writes /config.json with exactly Config's fields (env, label, apiBase, studioUrl, authkit) from the environment's EnvConfig.
const config = await res.json() as Config;
// Real sign-in where the environment configures AuthKit. Finishing the
// redirect back from AuthKit happens inside createAuth, before the first render.
const auth = config.authkit ? await createAuth(config.authkit, location.origin, sessionLost) : null;
initAuth(auth);
initStore(initialState(config, auth?.user() != null));
initApi();
const root = document.getElementById("root");
if (!root) throw new Error("The Console page has no #root element.");
render(<App />, root);
if (auth) void startSession();
